'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/es6.string.big.js
// module id = 800
// module chunks = 32